export default "__VITE_ASSET__BsqUj5pQ__"